import { render, staticRenderFns } from "./Agrimontana.vue?vue&type=template&id=1bf2c088&scoped=true"
import script from "./Agrimontana.vue?vue&type=script&lang=js"
export * from "./Agrimontana.vue?vue&type=script&lang=js"
import style0 from "./Agrimontana.vue?vue&type=style&index=0&id=1bf2c088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2c088",
  null
  
)

export default component.exports